import { FC, useState } from "react";
import ImagePlaceholder, {
  ImagePlaceholderVariant,
} from "components/ImagePlaceholder/ImagePlaceholder";
import { isValidImageUrl } from "utils/imageUtils";

export interface SafeImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  imgClassName?: string;
  placeholderVariant?: ImagePlaceholderVariant;
  placeholderCompact?: boolean;
  objectFit?: "cover" | "contain";
}

const SafeImage: FC<SafeImageProps> = ({
  src,
  alt,
  className = "w-full h-full",
  imgClassName = "",
  placeholderVariant = "default",
  placeholderCompact = false,
  objectFit = "cover",
}) => {
  const [failed, setFailed] = useState(false);
  const showImage = isValidImageUrl(src) && !failed;

  if (!showImage) {
    return (
      <ImagePlaceholder
        label={alt}
        variant={placeholderVariant}
        compact={placeholderCompact}
        className={className}
      />
    );
  }

  const fitClass =
    objectFit === "contain" ? "object-contain" : "object-cover";

  return (
    <img
      src={src}
      alt={alt}
      className={`w-full h-full ${fitClass} ${imgClassName}`}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
};

export default SafeImage;
